const $ = jQuery.noConflict();
import Global from './global';
import addToCartSingle from './addToCart';
import Fancybox from './fancybox';

'use strict';

const loadMore = {
    $wrap: $('.product-listing__container'),
    isLoading: false, // Prevents multiple AJAX requests
    hasMoreProducts: true, // Tracks if more products exist
    currentPage: loadmoreparams.current_page || 1,
    maxPages: parseInt(document.querySelector('.site-main')?.getAttribute('data-max-num') || 1, 10),
    searchQuery: new URLSearchParams(window.location.search).get('q') || '', // Get 'q' from URL

    init: function () {
        if ($('.searchanise-search-results-page').length) {
            $(window).on('scroll', this.onScroll.bind(this));
        }
    },

    onScroll: function () {
        if (this.isLoading || !this.hasMoreProducts) return;

        const containerTop = this.$wrap.offset().top;
        const containerHeight = this.$wrap.outerHeight();
        const scrollPosition = $(window).scrollTop();
        const windowHeight = $(window).height();

        // Check if the user scrolled to the bottom of $wrap
        if (scrollPosition + windowHeight >= containerTop + containerHeight - 50) {
            this.loadMoreProducts();
        }
    },

    loadMoreProducts: function () {
        if (this.currentPage >= this.maxPages) {
            this.hasMoreProducts = false;
            return;
        }

        this.isLoading = true;
        this.showPreloader();
        $.ajax({
            url: kadraGlobal.baseUrl + 'loadmoreSearch',
            type: 'POST',
            data: {
                action: 'loadmoreSearch',
                page: this.currentPage,
                s: this.searchQuery
            },
            success: (res) => this.handleSuccess(res),
            error: (error) => this.handleError(error),
            complete: () => {
                this.isLoading = false;
            }
        });
    },

    handleSuccess: function (res) {
        this.removePreloader();

        if (!res || !res.responseText || !res.responseText.length) {
            this.hasMoreProducts = false;
            return;
        }

        $(this.$wrap).append(res.responseText);
        this.currentPage++;
        loadmoreparams.current_page++;

        this.reinitUI();
    },

    handleError: function (error) {
        this.removePreloader();

        if (!error || !error.responseText || error.data === 'required data not sent.') {
            this.hasMoreProducts = false;
            return;
        }

        $(this.$wrap).append(error.responseText);
        this.currentPage++;
        loadmoreparams.current_page++;

        this.reinitUI();
    },

    reinitUI: function () {
        Global.functions.equalHeights($('.js-product-info-box__title'));

        $('.js-search-zoom-img').each((i, el) => {
            const searchPopup = $(el).parents('.js-search-popup').find('.js-product-info-box-popup');
            Fancybox.fancyboxPopup(el, searchPopup);
        });
    },

    showPreloader: function () {
        if (!this.hasMoreProducts) return;

        $(this.$wrap).append(`
            <div class="preloader-container js-preloader">
                <span class="loader"></span>
            </div>
        `);
    },

    removePreloader: function () {
        $('.js-preloader').remove();
    }
};

export default loadMore;
